<template lang="pug">
    RequestAnalyze
</template>
<script>
import RequestAnalyze from "@/view/dashboard/RequestAnalyze"

import bus from "@/libs/bus.js";
export default {
    name: "HomePage",
    components: {
        RequestAnalyze
    },
    data() {
        return {
        }
    },
    methods: {     
    },
    mounted() { 
    },
    computed: {
    }
};
</script>



// WEBPACK FOOTER //
// src/view/HomePage.vue